var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nav-title bold upper xs-f-medium lg-f-small max-at-tweak brand-color-1"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }